<footer class="footer-container-wrapper">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md footer-logo">
                <img class="footerLogo" src="./assets/images/logo.png" alt="BCL" width="210" />
                <p>
                    BajajCapital is India’s premier investment services group engaged inter-alia in the distribution
                    of mutual funds, insurance, fixed deposits, bonds, loans et al.
                </p>
            </div>
            <div class="col-12 col-md footer-nav">
                <h4>Offering
                </h4>
                <ul>
                    <li>
                        <a href="https://onlinemf.bajajcapital.com/Default.aspx">Mutual Funds
                        </a>
                    </li>
                    <li>
                        <a href="https://www.bajajcapitalinsurance.com/">Insurance
                        </a>
                    </li>
                    <li>
                        <a href="https://www.bajajcapital.com/bonds">Bonds
                        </a>
                    </li>
                    <li>
                        <a target="_blank"
                            href="https://www.bajajcapitalone.com/nps/?utm_source=BCL&utm_medium=HomePage&utm_campaign=AboutUs">National
                            Pension System (NPS)
                        </a>
                    </li>
                    <li>
                        <a href="https://bajajcapital.com/fixed-deposits/fixed-deposit-introduction.aspx">Fixed
                            Deposits
                        </a>
                    </li>
                    <li>
                        <a href="https://www.bajajcapitalone.com/loans/home-loan/campaign/002/apply-now.html">Home
                            Loan
                        </a>
                    </li>
                    <li>
                        <a href="https://bajajcapital.com/beautiful-minds/index.aspx">Exclusively for Women
                        </a>
                    </li>
                    <li>
                        <a href="https://bajajcapital.com/mutual-funds/mf-amc.aspx">AMC for Investments
                        </a>
                    </li>
                    <li>
                        <a href="http://www.anindia.com/">Partner With Us
                        </a>
                    </li>
                </ul>
            </div>
            <div class="col-12 col-md footer-nav">
                <h4>Calculators
                </h4>
                <ul>
                    <li>
                        <a href="https://bajajcapital.com/financial-calculators/sip-planner.aspx">Systematic
                            Investment Planner
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://www.bajajcapitalone.com/loans/home-loan/campaign/002/apply-now.html#EMICalculator">Home
                            loan EMI
                        </a>
                    </li>
                    <li>
                        <a href="https://www.bajajcapitalone.com/nps/#EMICalculator">Pension
                        </a>
                    </li>
                    <li>
                        <a href="https://bajajcapital.com/financial-calculators/marriage-planner.aspx">Child
                            Marriage Planner
                        </a>
                    </li>
                    <li>
                        <a href="https://bajajcapital.com/financial-calculators/maturity-amount-calculator.aspx">Maturity
                            Amount
                        </a>
                    </li>
                    <li>
                        <a href="https://bajajcapital.com/financial-calculators/human-life-value-calc.aspx">Human
                            Life Value
                        </a>
                    </li>
                    <li>
                        <a href="https://bajajcapital.com/financial-calculators/gratuity-calc.aspx">Gratuity
                        </a>
                    </li>
                    <li>
                        <a href="https://www.bajajcapital.com/tax-saving-solutions">Tax Saving
                        </a>
                    </li>
                    <li>
                        <a href="https://www.bajajcapital.com/retirement-planning">Retirement Planning
                        </a>
                    </li>
                    <li>
                        <a href="https://bajajcapital.com/financial-calculators/crorepati-planner.aspx">Crorepati
                        </a>
                    </li>
                </ul>
            </div>
            <div class="col-12 col-md footer-nav">
                <h4>Resources
                </h4>
                <ul>
                    <li>
                        <a href="https://www.bajajcapital.com/about-us">About Us
                        </a>
                    </li>
                    <li>
                        <a href="https://www.bajajcapital.com/rm-assistance">RM Assistance
                        </a>
                    </li>
                    <li>
                        <a href="https://www.bajajcapital.com/help-centre">Branch Locator
                        </a>
                    </li>
                    <li>
                        <a href="https://www.bajajcapital.com/careers">Careers
                        </a>
                    </li>
                    <li>
                        <a href="https://www.bajajcapital.com/customer-reviews">Customer Testimonials
                        </a>
                    </li>
                    <li>
                        <a href="https://www.bajajcapital.com/help-centre">Help Centre
                        </a>
                    </li>
                    <li>
                        <a href="https://www.bajajcapital.com/blog">Blog
                        </a>
                    </li>
                    <li>
                        <a href="https://bajajcapital.com/dpservices/dp-service.aspx">DP Services
                        </a>
                    </li>
                    <li>
                        <a href="https://bajajcapital.com/resources/social-media-policy.pdf">Other Policies
                        </a>
                    </li>
                    <li>
                        <a href="https://bajajcapital.com/research/investorindia.aspx">Information Centre
                        </a>
                    </li>
                    <li>
                        <a href="https://bajajcapital.com/publication-archive.aspx">Publications
                        </a>
                    </li>
                </ul>
            </div>
            <div class="col-12 col-md">
                <h4>Contact
                </h4>
                <p>
                    <a href="tel:1800313123123">
                        <strong>1800-313-123123
                        </strong>
                    </a>
                    <br /> Mon - Sat (10AM - 6PM)
                </p>
                <p>
                    In case of any queries, feel free to call or write to us. We will be very happy to assist you.
                </p>
                <p>
                    <a href="mailto:contactus@bajajcapital.com">contactus@bajajcapital.com
                    </a>
                </p>
                <ul class="social-links">
                    <li>
                        <a href="https://www.facebook.com/Bajajcapital/">
                            <img src="assets/images/facebook-icon.png" alt="" />
                        </a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/company/bajaj-capital-ltd">
                            <img src="assets/images/linkden-icon.png" alt="" />
                        </a>
                    </li>
                    <li>
                        <a href="https://twitter.com/mybajajcapital">
                            <img src="assets/images/twitter-icon.png" alt="" />
                        </a>
                    </li>
                    <li>
                        <a href="https://www.youtube.com/channel/UCHd387ggvz3JC7I9wVtPhtw">
                            <img src="assets/images/youtube-icon.png" alt="" />
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="footer-bottom-pane">
        <div class="container">
            <div class="row">
                <div class="col-md-5">
                    <p class="copyright">
                        Copyright © 2020 BajajCapital Limited
                    </p>
                </div>
                <div class="col-md-7">
                    <ul class="bottom-pane-links">
                        <li>
                            <a target="_blank" href="/assets/legal-disclaimer.pdf"
                                download="legal_disclaimer.pdf">Legal Disclaimer
                            </a>
                        </li>
                        <li>
                            <a target="_blank" href="/assets/privacy-policy.pdf"
                                download="privacy_policy.pdf">Privacy Policy
                            </a>
                        </li>
                        <li>
                            <a target="_blank" href="/assets/terms-and-conditions.pdf"
                                download="terms_and_conditions.pdf">Terms and Conditions
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</footer>